var _Close;
var _excluded = ["onClose", "tooltipText"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { func, node } from 'prop-types';
import { Close } from 'mosaic-react-icons';
import useMosaicTranslation from "../../i18n/useMosaicTranslation";
import SovosIconButton from "../../../sovos-icon-button";
var CloseButton = function CloseButton(_ref) {
  var onClose = _ref.onClose,
    tooltipText = _ref.tooltipText,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useMosaicTranslation = useMosaicTranslation(),
    t = _useMosaicTranslation.t;
  return /*#__PURE__*/React.createElement(SovosIconButton, _extends({
    onClick: onClose,
    tooltipText: tooltipText || t('close')
  }, rest), _Close || (_Close = /*#__PURE__*/React.createElement(Close, null)));
};
CloseButton.propTypes = {
  /**
   * Callback fired when the button is clicked
   */
  onClose: func.isRequired,
  /**
   * Tooltip for the button
   */
  tooltipText: node
};
export default CloseButton;